
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexxwfO12fEYuhv1KjUYbHhrSeqZxg3g4Ojsd8w4SS_HxkMeta } from "/Users/wilmerhenao/triduum/t&t/t2t-front/pages/index.vue?macro=true";
import { default as logoutVXafvA9MPtgmxQscCxkx_45Lc4Wj_4559PAPsud_45ancKkdgMeta } from "/Users/wilmerhenao/triduum/t&t/t2t-front/pages/logout.vue?macro=true";
import { default as Loginty53Qa3INDj6MKwq8w2yVhj44SSOxSjBJv60t5HdbgAMeta } from "/Users/wilmerhenao/triduum/t&t/t2t-front/pages/auth/Login.vue?macro=true";
import { default as Users6N443O4bI4Z7QYbPyi1vvhpxaJUzRyuJ8D_45AQeMRus8Meta } from "/Users/wilmerhenao/triduum/t&t/t2t-front/pages/tests/Users.vue?macro=true";
import { default as ReportsRZYSHWzVZHRtf0kV_45WXkfPNQXQ_5sASeNuUCxXb5MgYMeta } from "/Users/wilmerhenao/triduum/t&t/t2t-front/pages/admin/Reports.vue?macro=true";
import { default as RegisterhaBfy3TGBhkxRNbqPKxrzuzj2P8aeo8ttSqlq4K1z5YMeta } from "/Users/wilmerhenao/triduum/t&t/t2t-front/pages/auth/Register.vue?macro=true";
import { default as MyProfilelIUYJws74_45Z49OFlNnxsxXt2W2VBn4HixO1z_45qo23wEMeta } from "/Users/wilmerhenao/triduum/t&t/t2t-front/pages/user/MyProfile.vue?macro=true";
import { default as indexzmUZQOVCqPFIJFaucIrOzGPeOPwgLCC7UTOHZg_gnqoMeta } from "/Users/wilmerhenao/triduum/t&t/t2t-front/pages/apps/maps/index.vue?macro=true";
import { default as indexpv2u6MGZBk1lplrSiSAjfcQNbIP9dKOiHwrXC_4562fW8Meta } from "/Users/wilmerhenao/triduum/t&t/t2t-front/pages/apps/notes/index.vue?macro=true";
import { default as MyPurchasesd06vL1MU93H0WMyP6Zl0U55pUAA_D1P9ckEDD3cjxJwMeta } from "/Users/wilmerhenao/triduum/t&t/t2t-front/pages/user/MyPurchases.vue?macro=true";
import { default as indexJfN1ikocdXNUWbWwI1DEIut5JRmrCHjZDc_iDGTUgosMeta } from "/Users/wilmerhenao/triduum/t&t/t2t-front/pages/apps/contacts/index.vue?macro=true";
import { default as Reset_45PassworddzZPGr4DRgwZQTq8KsmOcLdHo3ZTwh_45mFJFNKY2fknQMeta } from "/Users/wilmerhenao/triduum/t&t/t2t-front/pages/auth/Reset-Password.vue?macro=true";
import { default as delete_45accountHBB7OAAyGNukGdDdHeh1bgNRzdyFORETlkDPhZohNWoMeta } from "/Users/wilmerhenao/triduum/t&t/t2t-front/pages/help/delete-account.vue?macro=true";
import { default as CheckoutXci9c8ZBlUz72xCURkhrxQYgc5PQAB0_SlfEg8iPj6EMeta } from "/Users/wilmerhenao/triduum/t&t/t2t-front/pages/apps/ecommerce/Checkout.vue?macro=true";
import { default as ProductspxCUNwfE8lAEn_45JX5m_45VunXb9D_45xfxWDrxH0sg74vH8Meta } from "/Users/wilmerhenao/triduum/t&t/t2t-front/pages/apps/ecommerce/Products.vue?macro=true";
import { default as ProductListpstX0JoYN1gxI1vP_452WFeExN3mp5HolVWmEJIGykpLoMeta } from "/Users/wilmerhenao/triduum/t&t/t2t-front/pages/apps/ecommerce/ProductList.vue?macro=true";
import { default as _91uuid_93sH75dRK2GeZgXimh_w57KWj2uHzYl6_45jmMTBCJwFFBwMeta } from "/Users/wilmerhenao/triduum/t&t/t2t-front/pages/auth/reset-password/[uuid].vue?macro=true";
import { default as checkoutMixinY4TVRY35WduK8tITtYRduuEg8siSDuQju7t_45brlQ7NYMeta } from "/Users/wilmerhenao/triduum/t&t/t2t-front/pages/apps/ecommerce/checkoutMixin.ts?macro=true";
import { default as _91id_93RSOHpObr6ZJX5ZChPDbXpP7z38H2SefcyhnnjkSffzoMeta } from "/Users/wilmerhenao/triduum/t&t/t2t-front/pages/apps/ecommerce/product/detail/[id].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/Users/wilmerhenao/triduum/t&t/t2t-front/pages/index.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutVXafvA9MPtgmxQscCxkx_45Lc4Wj_4559PAPsud_45ancKkdgMeta || {},
    component: () => import("/Users/wilmerhenao/triduum/t&t/t2t-front/pages/logout.vue")
  },
  {
    name: "auth-Login",
    path: "/auth/Login",
    meta: Loginty53Qa3INDj6MKwq8w2yVhj44SSOxSjBJv60t5HdbgAMeta || {},
    component: () => import("/Users/wilmerhenao/triduum/t&t/t2t-front/pages/auth/Login.vue")
  },
  {
    name: "tests-Users",
    path: "/tests/Users",
    component: () => import("/Users/wilmerhenao/triduum/t&t/t2t-front/pages/tests/Users.vue")
  },
  {
    name: "admin-Reports",
    path: "/admin/Reports",
    component: () => import("/Users/wilmerhenao/triduum/t&t/t2t-front/pages/admin/Reports.vue")
  },
  {
    name: "auth-Register",
    path: "/auth/Register",
    meta: RegisterhaBfy3TGBhkxRNbqPKxrzuzj2P8aeo8ttSqlq4K1z5YMeta || {},
    component: () => import("/Users/wilmerhenao/triduum/t&t/t2t-front/pages/auth/Register.vue")
  },
  {
    name: "user-MyProfile",
    path: "/user/MyProfile",
    component: () => import("/Users/wilmerhenao/triduum/t&t/t2t-front/pages/user/MyProfile.vue")
  },
  {
    name: "apps-maps",
    path: "/apps/maps",
    component: () => import("/Users/wilmerhenao/triduum/t&t/t2t-front/pages/apps/maps/index.vue")
  },
  {
    name: "apps-notes",
    path: "/apps/notes",
    component: () => import("/Users/wilmerhenao/triduum/t&t/t2t-front/pages/apps/notes/index.vue")
  },
  {
    name: "user-MyPurchases",
    path: "/user/MyPurchases",
    component: () => import("/Users/wilmerhenao/triduum/t&t/t2t-front/pages/user/MyPurchases.vue")
  },
  {
    name: "apps-contacts",
    path: "/apps/contacts",
    component: () => import("/Users/wilmerhenao/triduum/t&t/t2t-front/pages/apps/contacts/index.vue")
  },
  {
    name: "auth-Reset-Password",
    path: "/auth/Reset-Password",
    meta: Reset_45PassworddzZPGr4DRgwZQTq8KsmOcLdHo3ZTwh_45mFJFNKY2fknQMeta || {},
    component: () => import("/Users/wilmerhenao/triduum/t&t/t2t-front/pages/auth/Reset-Password.vue")
  },
  {
    name: "help-delete-account",
    path: "/help/delete-account",
    meta: delete_45accountHBB7OAAyGNukGdDdHeh1bgNRzdyFORETlkDPhZohNWoMeta || {},
    component: () => import("/Users/wilmerhenao/triduum/t&t/t2t-front/pages/help/delete-account.vue")
  },
  {
    name: "apps-ecommerce-Checkout",
    path: "/apps/ecommerce/Checkout",
    component: () => import("/Users/wilmerhenao/triduum/t&t/t2t-front/pages/apps/ecommerce/Checkout.vue")
  },
  {
    name: "apps-ecommerce-Products",
    path: "/apps/ecommerce/Products",
    component: () => import("/Users/wilmerhenao/triduum/t&t/t2t-front/pages/apps/ecommerce/Products.vue")
  },
  {
    name: "apps-ecommerce-ProductList",
    path: "/apps/ecommerce/ProductList",
    component: () => import("/Users/wilmerhenao/triduum/t&t/t2t-front/pages/apps/ecommerce/ProductList.vue")
  },
  {
    name: "auth-reset-password-uuid",
    path: "/auth/reset-password/:uuid()",
    meta: _91uuid_93sH75dRK2GeZgXimh_w57KWj2uHzYl6_45jmMTBCJwFFBwMeta || {},
    component: () => import("/Users/wilmerhenao/triduum/t&t/t2t-front/pages/auth/reset-password/[uuid].vue")
  },
  {
    name: "apps-ecommerce-checkoutMixin",
    path: "/apps/ecommerce/checkoutMixin",
    component: () => import("/Users/wilmerhenao/triduum/t&t/t2t-front/pages/apps/ecommerce/checkoutMixin.ts")
  },
  {
    name: "apps-ecommerce-product-detail-id",
    path: "/apps/ecommerce/product/detail/:id()",
    component: () => import("/Users/wilmerhenao/triduum/t&t/t2t-front/pages/apps/ecommerce/product/detail/[id].vue")
  }
]